import React from "react";
import Tabla from "./Tabla";

function ApiToken(props) {
  return <Tabla {...props} />;
}

export default ApiToken;
